import { ATTRIBUTION_PARAMS, FIRST_TOUCH_KEY, LAST_TOUCH_KEY } from './constants';

function isBrowser() {
  return typeof window !== 'undefined';
}

function readAttributionFromUrl() {
  if (!isBrowser()) return null;
  const params = new URLSearchParams(window.location.search);
  const data = {};

  ATTRIBUTION_PARAMS.forEach((param) => {
    const value = params.get(param);
    if (value) data[param] = value;
  });

  return Object.keys(data).length > 0 ? data : null;
}

export function captureAttribution() {
  if (!isBrowser()) return;

  const fromUrl = readAttributionFromUrl();
  if (!fromUrl) return;

  const payload = {
    ...fromUrl,
    referrer: document.referrer || undefined,
  };

  sessionStorage.setItem(LAST_TOUCH_KEY, JSON.stringify(payload));

  if (!sessionStorage.getItem(FIRST_TOUCH_KEY)) {
    sessionStorage.setItem(FIRST_TOUCH_KEY, JSON.stringify(payload));
  }
}

export function getAttributionPayload() {
  if (!isBrowser()) return {};

  const payload = {};
  const firstTouch = sessionStorage.getItem(FIRST_TOUCH_KEY);
  const lastTouch = sessionStorage.getItem(LAST_TOUCH_KEY);

  if (firstTouch) payload.first_touch = JSON.parse(firstTouch);
  if (lastTouch) payload.last_touch = JSON.parse(lastTouch);

  return payload;
}
